import { useEffect, useState } from 'react';
import OrderListTable from './OrderListTable';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import { useAppSelector } from '../../../Reducers/store';
import OrderApi from '../../../Api/OrderApi';
import { OrderCustom } from '../../../Models/OrderCustom';
import { Button, Select, TextInput } from 'flowbite-react';
import { OrderSearchRequest } from '../../../Models/OrderSearchRequest';
import { formatDateInputs } from '../../../Utils';

export default function OrderList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [orderListData, setorderListData] = useState<OrderCustom[]>([]);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<OrderSearchRequest>({
    orderStatus: 0,
    clientId: 0,
    fromDate: new Date(new Date().setDate(new Date().getDate() - 30))
      .toISOString()
      .split('T')[0],
    toDate: new Date().toISOString().split('T')[0],
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  useEffect(() => {
    getOrderListCustom();
  }, [userModel]);

  const getOrderListCustom = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        setButtonDisabled(true);
        return OrderApi.getOrderListCustom(formData)
          .then((res) => {
            setorderListData(res.data);
            setIsLoading(false);
            setButtonDisabled(false);
          })
          .catch((err) => {
            console.error(err);
            toast.error('Error');
            setIsLoading(false);
            setButtonDisabled(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
        setButtonDisabled(false);
      }
    }
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    getOrderListCustom();
  };

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Order List</div>
              </h1>
            </div>
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className=''>
            <form
              id='searchForm'
              onSubmit={onSubmit}
              className='flex gap-4 justify-center'
            >
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>Status:</div>
                <Select
                  id='orderStatus'
                  name='orderStatus'
                  onChange={handleChangeSelect}
                  value={formData.orderStatus ?? ''}
                  sizing='md'
                  required
                >
                  <option key={0} value={0}>
                    All
                  </option>
                  <option key={1} value={1}>
                    Open
                  </option>
                  <option key={2} value={2}>
                    Submitted
                  </option>
                </Select>
              </div>
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>From:</div>
                <TextInput
                  id='fromDate'
                  name='fromDate'
                  type='date'
                  placeholder='Date...'
                  onChange={handleChange}
                  value={formData.fromDate ?? ''}
                  sizing='md'
                  pattern='\d{4}-\d{2}-\d{2}'
                  required
                />
              </div>
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>To:</div>
                <TextInput
                  id='toDate'
                  name='toDate'
                  type='date'
                  placeholder='Date...'
                  onChange={handleChange}
                  value={formatDateInputs(formData.toDate ?? '')}
                  sizing='md'
                  pattern='\d{4}-\d{2}-\d{2}'
                  required
                />
              </div>
              <Button
                type='submit'
                form='searchForm'
                className='buttonMain'
                disabled={buttonDisabled}
              >
                Search
              </Button>
            </form>
          </div>
          <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-260px)] overflow-y-auto'>
            <OrderListTable data={orderListData} />
          </div>
        </div>
      </div>
    </>
  );
}
